import { WEASLEY_ELIGIBILITY_QUERY } from './graphql/queries/weasleyEligibilityQuery.gql';
import { getGlobals, getLocale, getToken } from '../globals';
import { apolloClient } from '../apollo';
import { logger } from '../logger';

import {
  WEASLEY_ELIGIBILITY_RESOURCE_OBJECT,
  WEASLEY_RAMP_ELMO_EXPERIMENT_NAMES,
} from './constants';

export const getWeasleyEligibility = async (): Promise<{
  eligible: boolean;
}> => {
  const { device } = getGlobals();
  const { country } = getLocale();

  try {
    const eligibilityResponse = await apolloClient.query({
      query: WEASLEY_ELIGIBILITY_QUERY,
      variables: {
        channel: device?.channel,
        countryCodeAsString: country,
        res: JSON.stringify(WEASLEY_ELIGIBILITY_RESOURCE_OBJECT),
        token: getToken(),
      },
    });
    const { data } = eligibilityResponse;
    const { treatments = [] } = data.elmoExperimentWithRealTimeFilters || {};

    const matchingExperiment = treatments.find((treatment: any) =>
      WEASLEY_RAMP_ELMO_EXPERIMENT_NAMES.includes(treatment?.experimentName),
    );

    if (matchingExperiment) {
      // If it is Control then traffic is not weasley eligible
      const returnObject = {
        eligible: matchingExperiment.treatmentName.startsWith('Trmt_'),
      };
      logger.info('getWeasleyEligibility_response', returnObject);
      return returnObject;
    }
    // No elmo experiment in response means use case is not controlled by
    // by elmo, we can safely assume that it is ramped to 100% on weasley
    // NOTE: Phase One ramp has covered most happy path and ramped to 100%
    logger.info('getWeasleyEligibility_eligible_with_no_elmo_response');
    return { eligible: true };
  } catch (err: any) {
    const { message, stack } = err;
    logger.warn('getWeasleyEligibility_eligible_missing_elmo_response', {
      message,
      stack,
    });
    // Default any error scenario to weasley application as xoon is on path
    // to deprecation and we dont want to add tech debt by redirecting to xoon
    return { eligible: true };
  }
};
